import getPagesArray from 'legacyfrontend/utils/get-pages-array';
const ClientPagination = ({ totalPages, currentPage, handleCurrentPage }) => {
  const pages = getPagesArray(totalPages);

  return (
    <div className='pagination-container'>
      <div
        className={`pagination__btn first ${currentPage === 1 ? 'active' : 'inactive'}`}
        onClick={() => {
          handleCurrentPage(1);
        }}
      >
        1
      </div>
      <div className={`pagination__more${currentPage > 4 ? ' show' : ''}`}>...</div>
      {totalPages > 1 && (
        <>
          {pages.map((page) => {
            if (page > currentPage - 3 && page < currentPage + 3) {
              return (
                <div
                  className={`pagination__btn ${currentPage === page ? 'active' : 'inactive'}`}
                  key={page}
                  onClick={() => {
                    handleCurrentPage(page);
                  }}
                >
                  {page}
                </div>
              );
            }
          })}
        </>
      )}
      {totalPages > 1 && (
        <>
          <div
            className={`pagination__more${
              currentPage < totalPages - 3 && totalPages > 4 ? ' show' : ''
            }`}
          >
            ...
          </div>
          <div
            onClick={() => {
              handleCurrentPage(totalPages);
            }}
            className={`pagination__btn last ${currentPage === totalPages ? 'active' : 'inactive'}`}
          >
            {totalPages}
          </div>
        </>
      )}
    </div>
  );
};

export default ClientPagination;
